import { render, staticRenderFns } from "./ContentWithCodeSnippet.vue?vue&type=template&id=7238e98f&scoped=true&"
import script from "./ContentWithCodeSnippet.vue?vue&type=script&lang=ts&"
export * from "./ContentWithCodeSnippet.vue?vue&type=script&lang=ts&"
import style0 from "./ContentWithCodeSnippet.vue?vue&type=style&index=0&id=7238e98f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238e98f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/opt/build/repo/components/storyblok/Header.vue').default})
